export enum ModuleType {
    Base = 0,
    Holland = 1,
    Gum = 2,
    Vdnh = 3,
    AkvaLushniki = 4,
    BobrLog = 5,
    LuzhnikiKatok = 6,
    LuzhnikiSber = 7,
    Buhtagold = 8,
    Elbrus = 9,
    PrimorskyOceanarium = 10
}